<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-flex uk-flex-between uk-flex-middle">
        <div>
          <h1 class="uk-h4 uk-margin-remove">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M5 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                <path d="M19 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                <path d="M19 8v5a5 5 0 0 1 -5 5h-3l3 -3m0 6l-3 -3"></path>
                <path d="M5 16v-5a5 5 0 0 1 5 -5h3l-3 -3m0 6l3 -3"></path>
              </svg>
            </span>
            Restwertbörse
          </h1>
        </div>
        <div class="uk-flex uk-flex-middle">
          <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-text">
            <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
            Zurück
          </a>
          <div class="uk-margin-left">
              <router-link class="uk-button uk-button-primary uk-button-small" :to="{ name: 'admin.exchange.vehicle.edit' }">
                <span data-uk-icon="plus-circle"></span>
                Fahrzeug anlegen
              </router-link>
            </div>
        </div>
      </div>
    </div>
    <div>
      <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom"
        v-if="vehicles.length && !loading">
        <div class="uk-card-body">
          <div class="uk-overflow-auto">
            <vehicle-table :vehicles="vehicles" @removed="getVehicles()"></vehicle-table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading && !vehicles.length" class="uk-margin-remove uk-h4">
      Keine Fahrzeuge vorhanden!
    </div>
    <div v-if="meta && meta.pagination.total_pages > 1" class="uk-margin-small">
      <pagination :pagination="meta.pagination" @pagination:switched="onPaginationSwitch"></pagination>
    </div>
  </div>
</template>
<script>
import ExchangeService from '@/services/exchange.service'
import VehicleTable from '@/components/admin/exchange/VehicleTable'
import Pagination from '@/components/Pagination'
export default {
  data() {
    return {
      vehicles: [],
      meta: null,
      loading: true
    }
  },
  components: {
    VehicleTable,
    Pagination
  },
  mounted() {
    this.getVehicles()
  },
  watch: {
    '$route.query': {
      handler(query) {
        this.getVehicles(1, query)
      },
      deep: true
    }
  },
  methods: {
    async getVehicles(page = this.$route.query.page, query = this.$route.query) {
      const vehicles = await ExchangeService.getVehicles(page, query)
      this.vehicles = vehicles.data.data
      this.meta = vehicles.data.meta
      this.loading = false
    },
    onPaginationSwitch(page) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const currentParams = Object.fromEntries(urlSearchParams.entries());
      const params = Object.assign({}, {...currentParams}, { page })
      this.addParamsToLocation({ ...params })
      this.getVehicles(params)
      window.scrollTo(0,0)
    },
    addParamsToLocation(params) {
      history.pushState(
        {},
        null,
        this.$route.path +
        '?' +
        Object.keys(params)
          .map(key => {
            return (
              encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
            )
          })
          .join('&')
      )
    }
  }
}
</script>
  